import { defineStore } from "pinia";

export const useUserStore = defineStore("user ", {
  state: () => ({
    userEditData: null,
  }),

  actions: {
    getEditData() {
      this.userEditData = JSON.parse(localStorage.getItem("user_edit_data"));
    },

    storeEditData(data) {
      if (!data) return;
      localStorage.setItem("user_edit_data", JSON.stringify(data));
    },

    clearEditData() {
      localStorage.removeItem("user_edit_data");
    },
  },
});
